import { useState } from "react";
import { Box, CircularProgress, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

import { QuoteDeduction } from "../../../../api/Quote/QuoteDeduction";
import { EQuoteDeductionStatus } from "../../../../api/Quote/EQuoteDeductionStatus";
import { EQuoteDeductionCategory } from "../../../../api/Quote/EQuoteDeductionCategory";
import { useSummaryStyles } from "./summary.styles";
import { PriceFormat } from "../../../../components/typography/PriceFormat";

interface Props {
  deduction: QuoteDeduction;
  onDelete: (quoteDeductionId: string, promoCode: string | null) => Promise<void>;
  hasRemoveButton: boolean;
}

export const DeductionLine = ({ deduction, onDelete, hasRemoveButton }: Props) => {
  const classes = useSummaryStyles();
  const [loading, setLoading] = useState(false);
  const handleDelete = async () => {
    try {
      setLoading(true);
      await onDelete(deduction.id, deduction.promoCode);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const status = (status: EQuoteDeductionStatus) => {
    switch (status) {
      case EQuoteDeductionStatus.Expired:
        return "Expired";
      case EQuoteDeductionStatus.NotActive:
        return "Not applicable";
      case EQuoteDeductionStatus.Removed:
        return "Not applicable";
    }
  };

  if (deduction.status === EQuoteDeductionStatus.Removed) {
    return <></>;
  }

  const statusSection = deduction.status !== EQuoteDeductionStatus.Applied && <span>{status(deduction.status)}</span>;

  const valueSection = deduction.status === EQuoteDeductionStatus.Applied && (
    <span
      style={
        hasRemoveButton &&
        !(
          deduction.category === EQuoteDeductionCategory.Promotion ||
          deduction.category === EQuoteDeductionCategory.Referral ||
          deduction.category === EQuoteDeductionCategory.Discount
        )
          ? { marginRight: "28px" }
          : {}
      }
    >
      -&nbsp;
      <PriceFormat value={deduction.discountValue ?? 0} />
    </span>
  );

  const removeSection = (deduction.category === EQuoteDeductionCategory.Promotion ||
    deduction.category === EQuoteDeductionCategory.Referral ||
    deduction.category === EQuoteDeductionCategory.Discount) && (
    <IconButton onClick={handleDelete} disabled={loading}>
      {loading ? <CircularProgress size="20px" /> : <CloseIcon fontSize="small" />}
    </IconButton>
  );

  return (
    <>
      <Box className={classes.summaryDiscount}>
        <p>Discount {deduction.promoCode && <>({deduction.promoCode})</>}</p>
        <Box className="summaryDiscountValue">
          {valueSection}
          {statusSection}
          {removeSection}
        </Box>
      </Box>
    </>
  );
};
